"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clampIfStreemshotRequestWasFulfilled = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
function clampIfStreemshotRequestWasFulfilled(streemshots) {
    return function (source) {
        return source.pipe((0, operators_1.withLatestFrom)((0, rxjs_1.merge)((0, rxjs_1.of)([]), streemshots)), (0, operators_1.filter)(([latestRequest, streemshots]) => {
            return streemshots.every(ss => ss.id !== latestRequest.streemshotId);
        }), (0, operators_1.map)(([latestRequest]) => latestRequest));
    };
}
exports.clampIfStreemshotRequestWasFulfilled = clampIfStreemshotRequestWasFulfilled;
//# sourceMappingURL=clamp_if_streemshot_request_was_fulfilled.js.map